<template>
  <!-- 使用 Vant Dialog 或 Popup 更适合移动端 -->
  <van-popup v-model="open" round closeable position="bottom" style="height: auto; max-height: 90vh; padding-top: 20px;">
    <div style="padding: 0 16px 20px;">
      <h3 style="font-size: 18px; font-weight: 600; margin-bottom: 20px; text-align: center;">{{ title }}</h3>

      <van-field
        v-model="form.type"
        label="类型"
        placeholder="请输入类型"
        required
        clearable
      />

      <div style="margin-top: 30px; display: flex; gap: 12px;">
        <van-button type="default" block @click="cancel">取消</van-button>
        <van-button type="primary" block @click="submitForm">确定</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { imageTypeAdd, imageTypeUpd } from "@/api/imageType";

export default {
  data() {
    return {
      title: "",
      open: false,
      form: {},
      rules: {},
    };
  },
  methods: {
    addCreateForm(platForm) {
      this.reset();
      this.open = true;
      this.title = "添加类型";
      this.form.platForm = platForm;
    },
    showCreateForm(record) {
      this.reset();
      this.open = true;
      this.form = { ...record };
      this.title = "修改类型";
    },
    reset() {
      this.form = {
        id: null,
        platForm: null,
        type: null,
      };
    },
    submitForm() {
      // 可加入简单校验
      if (!this.form.type || !this.form.type.trim()) {
        this.$toast.fail("请填写类型");
        return;
      }

      if (this.form.id != null) {
        imageTypeUpd(this.form).then(() => {
          this.$toast.success("修改成功");
          this.open = false;
          this.$emit("ok");
        }).catch(() => {});
      } else {
        imageTypeAdd(this.form).then(() => {
          this.$toast.success("新增成功");
          this.open = false;
          this.$emit("ok");
        }).catch(() => {});
      }
    },
    cancel() {
      this.open = false;
      this.$emit("ok");
    },
  },
};
</script>